import type { FaireProductEntity } from "../../entity_types/product";

export const p_89hzri8q58: FaireProductEntity = {
  token: "p_89hzri8q58",
  type: "product",
  name: "HAIR SPRITZ",
  brandToken: "b_5dagse75md",
  brandName: "Rowe Casa Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/d196fa80cc6947feec2d54d2b1b7ef61d25e36cf040049da02dedbd8fc29f55d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b9d225647f2f489ed25feceddbc2db8d776031e67475d6d0ac4e57fd89a0ead9.png",
  ],
  priceDollars: 16.8,
  description:
    'Are you looking for a pure and effective solution to thinning hair or balding? Rowe Casa Organics presents the all-natural hair spritz - a powerful restorative solution for combating balding and thinning and brittle hair.\n\nIts unique blend stimulates hair growth and adds volume, strength, and luster to your mane. It can be used by both men and women. And since our formulation is crafted solely from organic ingredients that you can trust, it’s also safe for kids! As a one-of-a-kind hair spritz without alcohol, its purity and potency have helped it rise to the top spot, quickly emerging as one of our top sellers.\n\nTO USE: Shake well. Spray onto hair or beard and massage into scalp or face. Best used after washing and before drying. May also be used on dry hair as a refresher as needed.\n\nINGREDIENTS: WITCH HAZEL, 100% PURE THERAPEUTIC GRADE ESSENTIAL OILS: ROSEMARY, CEDARWOOD, LAVENDER, TEA TREE.\n\nDimension: 1.9" x 4.4" x 1.9".',
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:15.935Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
